import { createAction } from "redux-actions";

export const READ_FIELD_PRO_REPO = "READ_FIELD_PRO_REPO";

export const readAllFieldProsFromRepo = createAction(READ_FIELD_PRO_REPO);
